import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
    <div style={{ textAlign: 'center', marginTop: '10vh' }}>
        <div className='d-flex justify-content-lg-center'>
            <img src="/images/tahpi-plus.png" alt="" style={{ width: '120px', marginTop: '120px', marginBottom: '50px'}}></img>
        </div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for does not exist.</p>
        <Link className="btn btn-lg btn-dark w-100 py-2 mt-3 rounded-0" to="/">Go to Home</Link>
    </div>
);

export default NotFoundPage;